module.exports = __webpack_public_path__ + "static/media/screenshot-menu-settings.cb02b1c2.jpeg";